import React, { ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { MainTitle } from 'common/components';
import { Flex } from 'components/styled/Flex';

export const ModalInfoCard = ({
  title,
  children,
  margin,
  borderBottom,
  padding,
}: {
  title: string;
  children: ReactNode;
  margin?: string;
  borderBottom?: string;
  padding?: string;
}) => {
  const { fontFamily } = useTheme();

  return (
    <Flex
      flexDirection="column"
      margin={margin || '0'}
      borderBottom={borderBottom}
      padding={padding}
    >
      <MainTitle fontFamily={fontFamily.semiBold} fontSize="1.125rem" fontWeight={600}>
        {title}
      </MainTitle>
      {children}
    </Flex>
  );
};
